/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetGooseGamesQuestsByTypeQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Float"];
  type: Types.GooseGameQuestType;
}>;

export type GetGooseGamesQuestsByTypeQuery = {
  gooseGameQuestsByType: Array<
    Pick<
      Types.GooseGameQuest,
      | "id"
      | "title"
      | "type"
      | "points_rewarded"
      | "completion_limit"
      | "question_string"
      | "question_answer"
      | "description"
      | "quest_event_activity_category"
      | "flash"
      | "hidden"
    >
  >;
};

export const GetGooseGamesQuestsByTypeDocument = gql`
  query GetGooseGamesQuestsByType(
    $event_id: Float!
    $type: GooseGameQuestType!
  ) {
    gooseGameQuestsByType(event_id: $event_id, type: $type) {
      id
      title
      type
      points_rewarded
      completion_limit
      question_string
      question_answer
      description
      quest_event_activity_category
      flash
      hidden
    }
  }
`;

/**
 * __useGetGooseGamesQuestsByTypeQuery__
 *
 * To run a query within a React component, call `useGetGooseGamesQuestsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGooseGamesQuestsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGooseGamesQuestsByTypeQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetGooseGamesQuestsByTypeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGooseGamesQuestsByTypeQuery,
    GetGooseGamesQuestsByTypeQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetGooseGamesQuestsByTypeQuery,
    GetGooseGamesQuestsByTypeQueryVariables
  >(GetGooseGamesQuestsByTypeDocument, baseOptions);
}
export function useGetGooseGamesQuestsByTypeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGooseGamesQuestsByTypeQuery,
    GetGooseGamesQuestsByTypeQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetGooseGamesQuestsByTypeQuery,
    GetGooseGamesQuestsByTypeQueryVariables
  >(GetGooseGamesQuestsByTypeDocument, baseOptions);
}
export type GetGooseGamesQuestsByTypeQueryHookResult = ReturnType<
  typeof useGetGooseGamesQuestsByTypeQuery
>;
export type GetGooseGamesQuestsByTypeLazyQueryHookResult = ReturnType<
  typeof useGetGooseGamesQuestsByTypeLazyQuery
>;
export type GetGooseGamesQuestsByTypeQueryResult =
  ApolloReactCommon.QueryResult<
    GetGooseGamesQuestsByTypeQuery,
    GetGooseGamesQuestsByTypeQueryVariables
  >;
